import React from "react";
import { ArrowDown, ArrowUp, GripVertical, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

function Hint({ item, dupOf }) {
  const renamed = item.original && item.name.trim().replace(/\s+/g, " ") !== item.original;
  const merging = item.sources.filter((s) => s !== item.original);
  return (
    <p className="text-[11px] text-slate-500">
      {item.uses ? `Used in ${item.uses} note${item.uses === 1 ? "" : "s"}` : item.original ? "Not used yet" : "New scene"}
      {renamed && <span className="text-sky-700"> · renamed from “{item.original}”</span>}
      {merging.length > 0 && <span className="text-sky-700"> · merging “{merging.join("”, “")}”</span>}
      {dupOf && <span className="font-semibold text-amber-700"> · same name as #{dupOf}, they'll merge</span>}
    </p>
  );
}

// One scene in the director's list: drag handle, number, editable name, ↑/↓, remove.
export default function SceneListRow({ item, i, last, dupOf, dragging, drag, onName, onMove, onRemove }) {
  return (
    <div data-scene-row onDragOver={(e) => { e.preventDefault(); drag.over(i); }} onDrop={(e) => e.preventDefault()}
      className={`flex items-start gap-2 rounded-lg border bg-white p-2 transition-[box-shadow,opacity] ${dragging ? "border-sky-300 opacity-60 shadow-lg" : "border-slate-200"}`} data-testid={`scene-list-row-${i}`}>
      <span draggable onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text/plain", String(i)); e.dataTransfer.setDragImage(e.currentTarget.closest("[data-scene-row]"), 16, 16); drag.start(i); }}
        onDragEnd={drag.end} className="mt-2 cursor-grab text-slate-300 hover:text-slate-500 active:cursor-grabbing" aria-label="Drag to reorder" data-testid={`scene-list-drag-${i}`}>
        <GripVertical className="h-4 w-4" />
      </span>
      <span className="mt-2 w-5 shrink-0 text-right text-xs font-bold tabular-nums text-slate-400">{i + 1}</span>
      <div className="min-w-0 flex-1 space-y-1">
        <Input value={item.name} onChange={(e) => onName(e.target.value)} className="h-9" aria-label={`Scene ${i + 1} name`} data-testid={`scene-list-name-${i}`} />
        <Hint item={item} dupOf={dupOf} />
      </div>
      <Button type="button" size="icon" variant="ghost" className="h-9 w-8" disabled={i === 0} onClick={() => onMove(-1)} aria-label="Move up" data-testid={`scene-list-up-${i}`}><ArrowUp className="h-4 w-4" /></Button>
      <Button type="button" size="icon" variant="ghost" className="h-9 w-8" disabled={last} onClick={() => onMove(1)} aria-label="Move down" data-testid={`scene-list-down-${i}`}><ArrowDown className="h-4 w-4" /></Button>
      <Button type="button" size="icon" variant="ghost" className="h-9 w-8 text-slate-400 hover:text-red-600" onClick={onRemove} aria-label="Remove scene" data-testid={`scene-list-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
    </div>
  );
}
